export default __webpack_public_path__ + "static/media/logoMainBlack.bbdbca5c.png";